import axios from './axios'

export const refreshToken = token => {
  return new Promise(async (resolve, reject) => {
    try {
      var path = 'https://securetoken.googleapis.com/v1/token?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw'
      var response = await axios.post(path, {
        grant_type: "refresh_token",
        refresh_token: token
      })
      // 
      resolve(response.data)
    } catch (err) {
      
      reject(err)
    }
  })
}
